import { useEffect, useState } from "react";
import AdminLogin from "@/components/admin/AdminLogin";
import Dashboard from "@/components/admin/Dashboard";

export default function Admin() {
  const [authed, setAuthed] = useState(() => !!localStorage.getItem("chwa_admin_token"));

  useEffect(() => {
    document.title = "CHWA Admin";
  }, []);

  const logout = () => {
    localStorage.removeItem("chwa_admin_token");
    setAuthed(false);
  };

  return authed ? (
    <Dashboard onLogout={logout} />
  ) : (
    <AdminLogin onSuccess={() => setAuthed(true)} />
  );
}
